document.addEventListener('DOMContentLoaded', () => {
    const nlSwitch = document.querySelector('.main-menu__item--wpml-ls-3-nl');
    const enSwitch = document.querySelector('.main-menu__item--wpml-ls-3-en');

    if(document.querySelector('.post-type-archive-case')){
        if(nlSwitch){
            var href = nlSwitch.querySelector('a').getAttribute('href');
            if(href.includes('cases')){ return; }
            href += 'cases/';
            nlSwitch.querySelector('a').setAttribute('href', href);
        } else if(enSwitch){
            var href = enSwitch.querySelector('a').getAttribute('href');
            if(href.includes('cases')){ return; }
            href += 'cases/';
            enSwitch.querySelector('a').setAttribute('href', href);
        }
    }
});